// extracted by mini-css-extract-plugin
export var deliveryRow = "_kr-a";
export var fixedHeight = "_kr-4";
export var freightLogo = "_kr-9";
export var fullWidth = "_kr-3";
export var priceColumn = "_kr-5";
export var radioSelected = "_kr-7";
export var radioUnselected = "_kr-6";
export var selectedOption = "_kr-2";
export var selectedOptionContainer = "_kr-1";
export var selection = "_kr-0";
export var tallSkeletonText = "_kr-8";